import { useHistory } from "react-router-dom";
import styled from "styled-components";
import { Routes } from "@lifeat/shared/system/RouteConstants";
import { LifeAtButtonV2 } from "@common/LifeAtButtonV2/LifeAtButtonV2";
import { Size } from "@themes/Device";
import { ScrollbarStyles } from "@themes/ScrollbarStyles";
import { buildRoute } from "@util/RouteUtil";

const Root = styled.div`
    min-height: 100dvh;
    background: ${({ theme }) => theme.backgroundPrimary};
    display: flex;
    flex-direction: column;
    align-items: center;
`;

const Container = styled.main`
    padding: 24px;
    width: clamp(0px, ${Size.laptop}, 100%);
`;

const RawData = styled.div`
    font-family: monospace;
    max-width: 120ch;
    height: 300px;
    overflow: auto;
    ${ScrollbarStyles}
`;

type AdminErrorProps = {
    message: string;
};

export function AdminError(props: AdminErrorProps) {
    const history = useHistory();

    const handleBack = () => {
        history.push(buildRoute(Routes.Admin));
    };

    return (
        <Root>
            <Container>
                <LifeAtButtonV2 onClick={handleBack}>{"<"} back</LifeAtButtonV2>
                <RawData>
                    <pre>{props.message}</pre>
                </RawData>
            </Container>
        </Root>
    );
}
